// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
  background: #f0f4f9;
  padding: 72px 0;
}
.about-inner {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 56px;
}
.about-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #EE5B43;
  background: rgba(238, 91, 67, 0.12);
  border-radius: 20px;
  padding: 6px 16px;
  margin-bottom: 20px;
}
 
.about-heading {
  font-size: 27px;
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 52px;
  line-height: 1.3;
}
 
.about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 56px;
  align-items: start;
}
 
.partner-card {
  background: #fff;
  border-radius: 14px;
  border: 0.5px solid #d1dce6;
  padding: 26px 28px;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
 
.partner-card:last-child {
  margin-bottom: 0;
}
 
.partner-card--link {
  text-decoration: none;
  transition: border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;
}
 
.partner-card--link:hover {
  border-color: #EE5B43;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(238, 91, 67, 0.12);
}
 
.partner-logo {
  height: 32px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
  object-position: left center;
  display: block;
}
 
.partner-logo--edhec {
  height: 54px;
}
 
.partner-desc {
  font-size: 14.5px;
  color: var(--body);
  line-height: 1.6;
  margin: 0;
}
 
.partner-about {
  font-size: 13.5px;
  color: var(--mut);
  line-height: 1.7;
  padding-top: 10px;
  border-top: 1px solid var(--line);
}
 
.about-right-text {
  font-size: 15.5px;
  font-weight: 500;
  color: var(--ink);
  line-height: 1.7;
  margin: 0 0 32px;
}
 
.about-divider {
  border: none;
  border-top: 1px solid var(--line);
  margin: 0 0 32px;
}
 
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0 0 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
 
.contact-list li {
  display: flex;
  align-items: center;
}
 
.contact-link {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14.5px;
  color: #EE5B43;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s ease;
}
 
.contact-link:hover {
  opacity: 0.75;
  text-decoration: underline;
}
 
.contact-link svg {
  color: #EE5B43;
  width: 16px;
  flex-shrink: 0;
}
 
.about-disclaimer {
  font-size: 15.5px;
  font-weight: 500;
  color: var(--ink);
  line-height: 1.7;
  margin: 0 0 32px;
}
 
@media (max-width: 768px) {
  .about-inner {
    padding: 0 24px;
  }
  .about-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
 
  .about-header {
    text-align: center;
  }
 
  .about-heading {
    text-align: center;
  }
 
  .partner-card {
    text-align: center;
    align-items: center;
  }
 
  .about-right-text {
    text-align: center;
  }
 
  .contact-list {
    align-items: flex-start;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }
 
  .about-disclaimer {
    text-align: center;
  }
}
 
/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .about-header {
    text-align: center;
  }
 
  .about-heading {
    text-align: center;
  }
 
  .about-eyebrow {
    display: inline-flex;
  }
 
  .partner-card {
    text-align: center;
    align-items: center;
  }
 
  .about-right-text {
    text-align: center;
  }
 
  .contact-list {
    align-items: flex-start;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }
 
  .about-disclaimer {
    text-align: center;
  }
}
 
@media (max-width: 360px) {
  .about-heading {
    font-size: 22px;
  }
 
  .partner-about {
    font-size: 12.5px;
  }
}
@media (min-width: 1850px) {
  .about-inner {
    max-width: 2000px;
    padding: 0 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/AboutSection/AboutSection.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".about-section {\n  background: #f0f4f9;\n  padding: 72px 0;\n}\n.about-inner {\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 0 56px;\n}\n.about-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #EE5B43;\n  background: rgba(238, 91, 67, 0.12);\n  border-radius: 20px;\n  padding: 6px 16px;\n  margin-bottom: 20px;\n}\n \n.about-heading {\n  font-size: 27px;\n  font-weight: 700;\n  color: var(--ink);\n  margin: 0 0 52px;\n  line-height: 1.3;\n}\n \n.about-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 56px;\n  align-items: start;\n}\n \n.partner-card {\n  background: #fff;\n  border-radius: 14px;\n  border: 0.5px solid #d1dce6;\n  padding: 26px 28px;\n  margin-bottom: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n \n.partner-card:last-child {\n  margin-bottom: 0;\n}\n \n.partner-card--link {\n  text-decoration: none;\n  transition: border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;\n}\n \n.partner-card--link:hover {\n  border-color: #EE5B43;\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(238, 91, 67, 0.12);\n}\n \n.partner-logo {\n  height: 32px;\n  width: auto;\n  max-width: 220px;\n  object-fit: contain;\n  object-position: left center;\n  display: block;\n}\n \n.partner-logo--edhec {\n  height: 54px;\n}\n \n.partner-desc {\n  font-size: 14.5px;\n  color: var(--body);\n  line-height: 1.6;\n  margin: 0;\n}\n \n.partner-about {\n  font-size: 13.5px;\n  color: var(--mut);\n  line-height: 1.7;\n  padding-top: 10px;\n  border-top: 1px solid var(--line);\n}\n \n.about-right-text {\n  font-size: 15.5px;\n  font-weight: 500;\n  color: var(--ink);\n  line-height: 1.7;\n  margin: 0 0 32px;\n}\n \n.about-divider {\n  border: none;\n  border-top: 1px solid var(--line);\n  margin: 0 0 32px;\n}\n \n.contact-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n \n.contact-list li {\n  display: flex;\n  align-items: center;\n}\n \n.contact-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14.5px;\n  color: #EE5B43;\n  font-weight: 600;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n}\n \n.contact-link:hover {\n  opacity: 0.75;\n  text-decoration: underline;\n}\n \n.contact-link svg {\n  color: #EE5B43;\n  width: 16px;\n  flex-shrink: 0;\n}\n \n.about-disclaimer {\n  font-size: 15.5px;\n  font-weight: 500;\n  color: var(--ink);\n  line-height: 1.7;\n  margin: 0 0 32px;\n}\n \n@media (max-width: 768px) {\n  .about-inner {\n    padding: 0 24px;\n  }\n  .about-grid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n \n  .about-header {\n    text-align: center;\n  }\n \n  .about-heading {\n    text-align: center;\n  }\n \n  .partner-card {\n    text-align: center;\n    align-items: center;\n  }\n \n  .about-right-text {\n    text-align: center;\n  }\n \n  .contact-list {\n    align-items: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n  }\n \n  .about-disclaimer {\n    text-align: center;\n  }\n}\n \n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .about-header {\n    text-align: center;\n  }\n \n  .about-heading {\n    text-align: center;\n  }\n \n  .about-eyebrow {\n    display: inline-flex;\n  }\n \n  .partner-card {\n    text-align: center;\n    align-items: center;\n  }\n \n  .about-right-text {\n    text-align: center;\n  }\n \n  .contact-list {\n    align-items: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n  }\n \n  .about-disclaimer {\n    text-align: center;\n  }\n}\n \n@media (max-width: 360px) {\n  .about-heading {\n    font-size: 22px;\n  }\n \n  .partner-about {\n    font-size: 12.5px;\n  }\n}\n@media (min-width: 1850px) {\n  .about-inner {\n    max-width: 2000px;\n    padding: 0 140px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
